import type {
  IControlSettingData,
  IDynamicControlSetting,
} from '~/presentation/reports/common/type';

import { SESSION_BY_DEVICE_TYPE_PRESET, SESSION_BY_DEVICE_TYPE_UI_PRESET } from './device-type';
import { COMPLETED_CHECKOUT_PRESET, COMPLETED_CHECKOUT_UI_PRESET } from './complete-checkout';
import { ADD_TO_CART_RATE_PRESET, ADD_TO_CART_RATE_UI_PRESET } from './add-to-cart-rate';
import { REACHED_CHECKOUT_PRESET, REACHED_CHECKOUT_UI_PRESET } from './reached-checkout';
import { VISITOR_BY_TYPE_PRESET, VISITOR_BY_TYPE_UI_PRESET } from './visitor-by-type';
import { CONVERSION_RATE_PRESET, CONVERSION_RATE_UI_PRESET } from './conversion-rate';
import { TRAFFIC_SOURCE_PRESET, TRAFFIC_SOURCE_UI_PRESET } from './traffic-source';
import { CART_ADDITION_PRESET, CART_ADDITION_UI_PRESET } from './cart-addition';
import { ADD_TO_CART_PRESET, ADD_TO_CART_UI_PRESET } from './add-to-cart';
import { PAGEVIEW_PRESET, PAGEVIEW_UI_PRESET } from './pageviews';
import { SESSION_PRESET, SESSION_UI_PRESET } from './sessions';
import { VISITOR_PRESET, VISITOR_UI_PRESET } from './visitors';
import { REVENUE_PRESET, REVENUE_UI_PRESET } from './revenue';
import { ORDER_DATA_PRESET, ORDER_UI_PRESET } from './order';
import { BR_PRESET, BR_UI_PRESET } from './bounce-rate';
import { RPV_PRESET, RPV_UI_PRESET } from './rpv';
import { AOV_PRESET, AOV_UI_PRESET } from './aov';
import { CTR_PRESET, CTR_UI_PRESET } from './ctr';
import { AVG_PRESET, AVG_UI_PRESET } from './avg';
import { EReportPresetKey } from '../types';

export const REPORT_DATA_PRESET: Record<EReportPresetKey, IControlSettingData> = {
  [EReportPresetKey.ORDER]: ORDER_DATA_PRESET,
  [EReportPresetKey.SESSION]: SESSION_PRESET,
  [EReportPresetKey.PAGEVIEW]: PAGEVIEW_PRESET,
  [EReportPresetKey.BR]: BR_PRESET,
  [EReportPresetKey.VISITOR]: VISITOR_PRESET,
  [EReportPresetKey.RPV]: RPV_PRESET,
  [EReportPresetKey.REVENUE]: REVENUE_PRESET,
  [EReportPresetKey.AOV]: AOV_PRESET,
  [EReportPresetKey.CART_ADDITION]: CART_ADDITION_PRESET,
  [EReportPresetKey.ADD_TO_CART_RATE]: ADD_TO_CART_RATE_PRESET,
  [EReportPresetKey.REACHED_CHECKOUT]: REACHED_CHECKOUT_PRESET,
  [EReportPresetKey.COMPLETED_CHECKOUT]: COMPLETED_CHECKOUT_PRESET,
  [EReportPresetKey.SESSION_BY_DEVICE_TYPE]: SESSION_BY_DEVICE_TYPE_PRESET,
  [EReportPresetKey.VISITOR_BY_TYPE]: VISITOR_BY_TYPE_PRESET,
  [EReportPresetKey.SESSION_BY_TRAFFIC_SOURCE]: TRAFFIC_SOURCE_PRESET,
  [EReportPresetKey.CTR]: CTR_PRESET,
  [EReportPresetKey.AVG]: AVG_PRESET,
  [EReportPresetKey.ADDED_TO_CART]: ADD_TO_CART_PRESET,
  [EReportPresetKey.CONVERSION_RATE]: CONVERSION_RATE_PRESET,
};

export const REPORT_UI_PRESET: Record<EReportPresetKey, IDynamicControlSetting> = {
  [EReportPresetKey.ORDER]: ORDER_UI_PRESET,
  [EReportPresetKey.SESSION]: SESSION_UI_PRESET,
  [EReportPresetKey.PAGEVIEW]: PAGEVIEW_UI_PRESET,
  [EReportPresetKey.BR]: BR_UI_PRESET,
  [EReportPresetKey.VISITOR]: VISITOR_UI_PRESET,
  [EReportPresetKey.RPV]: RPV_UI_PRESET,
  [EReportPresetKey.REVENUE]: REVENUE_UI_PRESET,
  [EReportPresetKey.AOV]: AOV_UI_PRESET,
  [EReportPresetKey.CART_ADDITION]: CART_ADDITION_UI_PRESET,
  [EReportPresetKey.ADD_TO_CART_RATE]: ADD_TO_CART_RATE_UI_PRESET,
  [EReportPresetKey.REACHED_CHECKOUT]: REACHED_CHECKOUT_UI_PRESET,
  [EReportPresetKey.COMPLETED_CHECKOUT]: COMPLETED_CHECKOUT_UI_PRESET,
  [EReportPresetKey.SESSION_BY_DEVICE_TYPE]: SESSION_BY_DEVICE_TYPE_UI_PRESET,
  [EReportPresetKey.VISITOR_BY_TYPE]: VISITOR_BY_TYPE_UI_PRESET,
  [EReportPresetKey.SESSION_BY_TRAFFIC_SOURCE]: TRAFFIC_SOURCE_UI_PRESET,
  [EReportPresetKey.CTR]: CTR_UI_PRESET,
  [EReportPresetKey.AVG]: AVG_UI_PRESET,
  [EReportPresetKey.ADDED_TO_CART]: ADD_TO_CART_UI_PRESET,
  [EReportPresetKey.CONVERSION_RATE]: CONVERSION_RATE_UI_PRESET,
};
